// useSettings — shared hook for global platform settings
// Usage: const { lotSize, isMarketOpen, getExpiry } = useSettings();

const DEFAULTS = {
  lotSizes: { 'NIFTY': 65, 'BANKNIFTY': 30, 'FINNIFTY': 40, 'SENSEX': 20 },
  marketOpen:  { h: 9,  m: 15 },
  marketClose: { h: 15, m: 29 },
  forceOpen: false,
  forceOpenFrom: '09:15',
  forceOpenTo:   '15:29',
  weekendMarketDays: [],
  forceExpiry: { NIFTY: '', BANKNIFTY: '', FINNIFTY: '', SENSEX: '' },
};

export function getSettings() {
  try {
    const saved = JSON.parse(localStorage.getItem('algrok_settings') || '{}');
    return {
      ...DEFAULTS,
      ...saved,
      lotSizes   : { ...DEFAULTS.lotSizes,    ...(saved.lotSizes    || {}) },
      forceExpiry: { ...DEFAULTS.forceExpiry, ...(saved.forceExpiry || {}) },
    };
  } catch { return DEFAULTS; }
}

export function getLotSize(symbol) {
  const s = getSettings();
  const key = symbol.replace(' 50','').replace('NIFTY 50','NIFTY');
  return s.lotSizes[key] || 1;
}

export function isMarketOpen() {
  const s   = getSettings();
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  const day = now.getDay();
  const h   = now.getHours();
  const m   = now.getMinutes();
  const todayStr = now.toISOString().split('T')[0];

  // Force open override
  if (s.forceOpen) {
    const [fh, fm] = s.forceOpenFrom.split(':').map(Number);
    const [th, tm] = s.forceOpenTo.split(':').map(Number);
    const nowMin = h * 60 + m;
    return nowMin >= fh * 60 + fm && nowMin <= th * 60 + tm;
  }

  // Weekend market day override
  if (day === 0 || day === 6) {
    return s.weekendMarketDays.includes(todayStr);
  }

  const nowMin   = h * 60 + m;
  const openMin  = s.marketOpen.h  * 60 + s.marketOpen.m;
  const closeMin = s.marketClose.h * 60 + s.marketClose.m;
  return nowMin >= openMin && nowMin <= closeMin;
}

export function getForceExpiry(symbol) {
  const s = getSettings();
  const key = symbol.replace(' 50','').replace('NIFTY 50','NIFTY');
  return s.forceExpiry?.[key] || null;
}
